import React from "react";
import classes from "../MasterDashboard.module.css";

const StatTile = ({ icon, label, value, badge, badgeTone, sublabel, labelClassName }) => (
  <div className={classes.statTile}>
    <div className={classes.statIcon}>{icon}</div>
    <div className={classes.statBody}>
      <div className={`${classes.statLabel} ${labelClassName ? classes[labelClassName] || "" : ""}`}>{label}</div>
      <div className={classes.statValue}>{value}</div>
      {badge && (
        <span className={`${classes.statBadge} ${classes[badgeTone] || ""}`}>
          {badge}
        </span>
      )}
      {sublabel && <div className={classes.statSublabel}>{sublabel}</div>}
    </div>
  </div>
);

export default StatTile;
